'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/es-errors/syntax.js
// module id = ../../../../es-errors/syntax.js
// module chunks = 5